import { Helmet } from 'react-helmet-async';
import { CheckoutView } from 'src/sections/product/checkout/view';

// ----------------------------------------------------------------------

export default function CheckoutPageV2() {
  return (
    <>
      <Helmet>
        <title>Checkout</title>
      </Helmet>

      <CheckoutView layoutVariant="orderingV2" />
    </>
  );
}
